import {
  RegularSelectInput,
  Show,
  SwitchInput,
  TextArea,
  TextInput,
} from "components/core";

import CommentView from "components/cards/comment-view";
import { FC } from "react";
import { FormikProps } from "formik";
import { GetOfferComments_getOfferComments } from "_graphql/queries/kek/__generated__/GetOfferComments";
import { KEKOffer_findSingleOffer } from "_graphql/queries/kek/__generated__/KEKOffer";
import { Treaty_treaty } from "_graphql/queries/__generated__/Treaty";
import { XCircleIcon } from "@heroicons/react/24/outline";

export interface ApproveTreatyFormProps {
  form: FormikProps<any>;
  treaty?: Treaty_treaty | null;
  comments: (GetOfferComments_getOfferComments | null)[];
}

const ApproveTreatyForm: FC<ApproveTreatyFormProps> = ({
  form,
  treaty,
  comments,
}) => {
  return (
    <div className="space-y-1">
      {" "}
      {/* Removed divide-y for cleaner spacing */}
      {/* Offer Information Section */}
      <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
        <h3 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100 mb-3">
          Treaty Details
        </h3>
        <dl className="space-y-2">
          {/* Display Originally Proposed Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Insurance company:
            </dt>
            <dd className="text-sm font-semibold text-primary-600 dark:text-primary-400">
              {/* Use toFixed for consistent decimal places, handle potential undefined */}
              {treaty?.insurer?.insurer_company_name ?? "N/A"}
            </dd>
          </div>

          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Treaty Program:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {treaty?.treaty_program?.treaty_name ?? "N/A"}
            </dd>
          </div>
        </dl>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
          Please review the Treaty details above. If everything looks correct,
          you can proceed to approve the offer. If you need to make changes,
          please update the fields accordingly.
        </p>
      </div>
      {/* {JSON.stringify(form.values, null, 2)} */}
      {/* Status Selection Section */}
      <div>
        <RegularSelectInput
          id={"status"}
          label={"Approval Status"}
          {...form}
          options={[
            {
              label: "Approve",
              value: "APPROVED",
            },
            {
              label: "Request Changes",
              value: "MODIFY",
            },
            {
              label: "Delete",
              value: "DELETE",
            },
          ]}
        />
      </div>
      <Show if={Boolean(form.values.status === "APPROVED")}>
        <div className="space-y-3 pt-3">
          <div className="rounded-md bg-red-50 p-4 dark:bg-red-500/15 dark:outline dark:outline-red-500/25">
            <div className="flex">
              <div className="shrink-0">
                <XCircleIcon
                  aria-hidden="true"
                  className="size-5 text-red-400"
                />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
                  By approving this treaty, both placing and cover notes will be
                  digitally signed
                </h3>
              </div>
            </div>
          </div>
          <TextInput
            id="approval_date"
            label="Approval Date"
            type="date"
            {...form}
          />
        </div>
      </Show>
      <Show
        if={Boolean(
          form.values.status === "MODIFY" || form.values.status === "DELETE"
        )}
      >
        <div className="pt-3">
          <TextArea
            id="message"
            label="Reason for Changes or Deletion"
            {...form}
            className="w-full"
            placeholder="Type your message here..."
          />
        </div>
      </Show>
    </div>
  );
};

export default ApproveTreatyForm;
